import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { ReactiveFormsModule } from "@angular/forms";
import { NGX_ERRORS_DECLARATIONS } from "@ngspot/ngx-errors";
import { TranslateModule } from "@ngx-translate/core";

import { UIModule } from "@intocare/ui";
import { IcNgxErrorsDirective } from "@intocare/util";

import { FormsDirectivesModule } from "../directives";
import { AddressFormComponent } from "./components/address-form/address-form.component";
import { LocationInputComponent } from "./components/input/input.component";
import { LocationInputCountryCodeComponent } from "./components/input-country-code/input-country-code.component";
import { AutocompletionPlaceDirective } from "./directives/autocompletion-place.directive";

@NgModule({
	imports: [
		CommonModule,
		ReactiveFormsModule.withConfig({ callSetDisabledState: "whenDisabledForLegacyCode" }),
		FormsDirectivesModule,
		UIModule,
		TranslateModule,
		IcNgxErrorsDirective,
		...NGX_ERRORS_DECLARATIONS,
	],
	declarations: [
		AddressFormComponent,
		LocationInputComponent,
		AutocompletionPlaceDirective,
		LocationInputCountryCodeComponent,
	],
	exports: [LocationInputComponent, AddressFormComponent, LocationInputCountryCodeComponent],
})
export class AddressFormModule {}
